<template>
  <div class="body">
      <Headtow></Headtow>
      <div id="w-center">
        <div id="Breadcrumb">
          <i class="el-icon-house Breadcrumb-i" ></i>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>专家介绍</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 左侧 -->
        <div class="w-expert">
          <div id="products_type">
            <el-radio-group v-model="tabPosition" @change="type" size="medium">
              <el-radio-button label="1" >全部</el-radio-button>
              <el-radio-button  v-for="(item, index) in types" :label="item.id" :key="item.id">{{item.title}}</el-radio-button>
             </el-radio-group>
          </div>
          <div class="h-30"></div>
          <ul id="products-content" class="expert-content"  v-loading="loading">
              <li v-for="(item, index) in list" :key="item.id">
                <router-link :to="{path:'/ExpertCont',query: {index: 3,id:item.id}}">
                  <div class="expert-content-left">
                      <img :src="item.picurl" alt="">
                  </div>
                  <div class="products-content-center expert-content-center">
                      <p class="products-content-center-title">{{item.title}}<span>{{item.zw}}</span></p>
                      <p class="expert-content-center-jianjie ov2">{{item.rz}}</p>
                      <p class="expert-content-center-shanchang ov1"><span>擅长：</span>{{item.sc}}</p>
                      <p class="expert-content-center-shanchang ov2"><span>简介：</span>{{item.introduction}}</p>
                  </div>
                  </router-link>
                  <div class="products-content-right">
                     <!-- <el-button>产品咨询</el-button> -->
                     <div class="h-40"></div>
                     <el-button  @click="dialogFormVisiblezj = true">专家帮我挑</el-button>
                  </div>
                  <div class="clear"></div>

               </li>
          </ul>
          
          <el-dialog title="专家帮我挑" :visible.sync="dialogFormVisiblezj" >
              <Productzjzj :productid='info.id' :title='info.title' @handleClosezj="handleClosezj"></Productzjzj>
          </el-dialog>


          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="12"
              @current-change="handleCurrentChange"
              :total="total">
            </el-pagination>
          </div>
        </div>
        <!-- 左侧结束 -->
      </div>
      <Foot></Foot>
  </div>

</template>

<script>

import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import productzjzj from '@/components/public/productzjzj.vue'
export default{
  data(){
    return {
      dialogFormVisiblezj: false,
      loading:true,
      list:[],
      page:1,
      total:0,
      info:[],
      tabPosition:'1',
      types:{},
      typeid:1,
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Productzjzj': productzjzj,


  },
  mounted () {
    this.recordapi();
  },
  methods:{
   recordapi(){
       var that = this;
       var userid = that.$cookieStore.getCookie('userid');
       that.$api.post("/Products/ExpertIndex",{'type':that.typeid,'page':this.page,}).then(res => {
         console.log(res);
         that.types= res.type;
         that.list= res.list.data;
         this.loading = false
         this.total = res.list.total

       });
   },
   // 分页
   handleCurrentChange(val) {
     console.log(`当前页: ${val}`);
     this.page = val;
     this.recordapi();
   },
   // 分类
   type:function(e){
     this.loading = true,
     this.typeid = e;
     this.recordapi();
   },
   // 关闭弹窗
   handleClosezj() {
     this.dialogFormVisiblezj = false
   },

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Expert.vue